import { inject, Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular/standalone';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private toastController = inject(ToastController);

  async showSuccess(message: string, duration = 5000): Promise<void> {
    await this.showToast(message, 'success', duration);
  }

  async showError(message: string, duration = 5000): Promise<void> {
    await this.showToast(message, 'danger', duration);
  }

  async showWarning(message: string, duration = 5000): Promise<void> {
    await this.showToast(message, 'warning', duration);
  }

  async showInfo(message: string, duration = 5000): Promise<void> {
    await this.showToast(message, '', duration);
  }

  private async showToast(
    message: string,
    color: 'success' | 'danger' | 'warning' | 'primary' | '' = '',
    duration = 5000
  ): Promise<void> {
    const toast = await this.toastController.create({
      message,
      duration,
      position: 'bottom',
      color,
      cssClass: `notification-toast toast-${color}`
    });

    await toast.present();
  }
}
